"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.panicEventDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const CoordinatesArray_1 = require("./CoordinatesArray");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const FirestoreTimestamp_1 = require("./firebase/FirestoreTimestamp");
function panicEventDeserialize(value, id) {
    var _a;
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        comments: (0, unwrap_1.default)(object.comments, deserializeString_1.deserializeString),
        creationTimestamp: (0, FirestoreTimestamp_1.firestoreTimestampDeserialize)(object.creationTimestamp),
        creatorId: (0, deserializeString_1.deserializeString)(object.creatorId),
        liveCoordinates: (0, unwrap_1.default)(object.liveCoordinates, CoordinatesArray_1.coordinatesArrayDeserialize),
        resolutionTimestamp: (_a = (0, unwrap_1.default)(object.resolutionTimestamp, FirestoreTimestamp_1.firestoreTimestampDeserialize)) !== null && _a !== void 0 ? _a : null,
        tripId: (0, unwrap_1.default)(object.tripId, deserializeString_1.deserializeString),
    };
}
exports.panicEventDeserialize = panicEventDeserialize;
